export default [
  {
    path: '/distributionManage',
    component: () => import('../pages/distribution/distributionManage.vue'),
    name: 'distributionManage',
    title: '提成设置',
    meta: {
      title: '提成设置',
    },
  },
  {
    path: '/distributionOrderManage',
    component: () =>
      import('../pages/distribution/distributionOrderManage.vue'),
    name: 'distributionOrderManage',
    title: '分销订单管理',
    meta: {
      title: '分销订单管理',
    },
  },
  {
    path: '/otaOrderManage',
    component: () =>
      import('../pages/distribution/otaOrderManage.vue'),
    name: 'otaOrderManage',
    title: 'OTA订单管理',
    meta: {
      title: 'OTA订单管理',
    },
  },
]
